import es from './es';
import en from './en';
import fr from './fr';
import it from './it';
import de from './de';
import pl from './pl';
import pt from './pt';

const translations = {
    es,
    en,
    fr,
    it,
    de,
    pl,
    pt,
};

export const SUPPORTED_LANGUAGES = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'pl', name: 'Polski', flag: '🇵🇱' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
];

export const DEFAULT_LANGUAGE = 'es';

export default translations;
